export default __webpack_public_path__ + "static/media/ic-garage.22b73c17.svg";